export default __webpack_public_path__ + "static/media/add-circle-blue.f325f4fa.svg";